/**
 * @packageDocumentation
 * @module      CorSystemState.ts
 * @description Displays text for system state (Associated, etc.) along with a colored icon.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement, property, css } from 'lit-element';
import SystemState from "./SystemState";
import { universalStyles } from "./CorMain";
let CorSystemState = class CorSystemState extends LitElement {
    constructor() {
        super(...arguments);
        this.state = '';
    }
    static get styles() {
        return css `
          ${universalStyles}

          #wrapper {
            display: flex;
            justify-items: left;
            align-items: center;
          } 
          
          sh-text {
            margin-left: 8px;
          }
        `;
    }
    render() {
        return html `
            <div id="wrapper">
                <sh-icon icon="circle-filled"
                         size="xs"
                         color="${SystemState.getIconColor(this.state)}" 
                         ></sh-icon>
                <sh-text>${SystemState.getFriendlyName(this.state)}</sh-text>
            </div>
        `;
    }
};
__decorate([
    property()
], CorSystemState.prototype, "state", void 0);
CorSystemState = __decorate([
    customElement('cor-system-state')
], CorSystemState);
export default CorSystemState;
//# sourceMappingURL=CorSystemState.js.map